var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.clientData)?_c('planner-container',{attrs:{"viewed-homes":_vm.viewedHomes,"have-routes":_vm.haveRoutes}}):_c('choose-client')],1)}
var staticRenderFns = []

export { render, staticRenderFns }